import HomeActionTypes from './home.types';
import { checkStatus } from './home.utils';
//import HOME_DATA from './home.data';

const INITIAL_STATE = {
    homeData: [],
    vehicleNo: ''
};

const HomeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case HomeActionTypes.CHECK_STATUS:
            return {
                ...state,
                homeData: checkStatus(action.payload)
            }

        case HomeActionTypes.RELOAD_DATA:
            return {
                ...state,
                homeData: []
            }

        case HomeActionTypes.VEHICLE_NO:
            return {
                ...state,
                vehicleNo: action.payload
            }
    
        default:
            return state;
    }
};

export default HomeReducer;